// Screenname:ItemCategoryMapping
// Developer Name: Jagadish.
// Created date on: 14 / 3 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class ItemCategoryMappingService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/TaxMAS/Create", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/TaxMAS/List");
  }
  getItemdata(storeid, categoryid) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/ItemStoreMappingMAP/GetItem?StoreId=" +
      storeid +
      "&CategoryId=" +
      categoryid
    );
  }

  getItemListdata(storeid, categoryid) {
    debugger
    return httpbaseURL.httpMSInventoryUrl.get(
      "/ItemStoreMappingMAP/GetItemList?StoreId=" +
      storeid +
      "&CategoryId=" +
      categoryid
    );
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/TaxMAS/Update", doc);
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete("/TaxMAS/Delete?id=" + doc);
  }
}
export default new ItemCategoryMappingService();
